import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import sha256 from 'js-sha256';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useParams } from 'react-router';
import { useHistory } from "react-router-dom";
import { FormFeedback, Input } from 'reactstrap';
import PasswordCheck from '../../utils/PasswordCheck';
import { changePass } from '../apiCall/LoginCall';

const ForgetPwd = () => {

    let lang = localStorage.getItem("lang") !== undefined ? localStorage.getItem("lang") : "tr"
    const [current, setCurrent] = useState("");

    const [pass, setPass] = useState();

    const [passwordRules, setPasswordRules] = useState()
    const [newPass, setNewPass] = useState();
    const [showform, setShowForm] = useState(true)
    // const[user, setUser] = useState()
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    let history = useHistory();
    const params = useParams()

    const user = atob(localStorage.getItem("user"))
    const userId = params.UserId ? Buffer.from("", 'base64').toString('ascii') : null
    const expireDate = params.ExpireDate ? Buffer.from(params.ExpireDate, 'base64').toString('ascii') : null

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };
    const passwordInputType = isPasswordVisible ? 'text' : 'password';


    const resetPassword = async (e) => {
        e.preventDefault();

        try {
            if (document.getElementById("password").className.includes("is-invalid")) {
                alert(lang === "tr" ? "Şifreniz belirtilen kurallara uymuyor" : "Your password does not meet the specified rules");
                return;
            }

            if (pass !== newPass) {
                alert(lang === "tr" ? "Şifreleriniz Eşleşmiyor" : "Your passwords do not match.");
                return;
            }

            const targetUser = userId || user;
            if (!targetUser) {
                throw new Error("No user identified for password change");
            }

            const response = await changePass(targetUser, pass, current);

            if (response.status === 200) {
                alert(lang === "tr" ?
                    "Şifreniz değiştirilmiştir... Ana Sayfaya yönlendirilmek için tıklayın." :
                    "Your password has been changed... Click to be redirected to the homepage."
                );
                setTimeout(() => {
                    history.push(`${process.env.PUBLIC_URL}/login`);
                }, 1000);
            } else {
                throw new Error(response.data.Status.Message);
            }
        } catch (error) {
            alert(lang === "tr" ?
                `Şifre değiştirilirken hata meydana geldi. ${error.message}` :
                `An error occurred while changing the password. ${error.message}`
            );
        }
    };

    useEffect(() => {

        if (expireDate !== null) {
            let strExpireDate = moment(expireDate)
            let newDate = new Date()
            const timeDiff = moment.duration(moment(newDate).diff(strExpireDate))
            if (parseInt(timeDiff._milliseconds) > 3600000) {
                setShowForm(false)
            }

        }


    }, [userId, expireDate])

    const [passwordRulesValidate, setPasswordRulesValidate] = useState(true)
    const passwordCheck = (e) => {
        setPasswordRulesValidate(e)
    }
    return (
        <>
            <div className="page-wrapper">
                <div className="container-fluid">
                    <div className="authentication-main">
                        <div className="row">
                            <div className="col-md-12 p-0">
                                <div className="auth-innerright">
                                    <div className="reset-password-box">
                                        <div className="card mb-0">
                                            {showform ?
                                                <form className="theme-form">
                                                    <h6 className="f-14 mt-4 mb-3">{lang === "tr" ? "Şifre Değiştirme" : "Change Password"}</h6>

                                                    <div className="form-group">
                                                        <label className="col-form-label">{lang === "tr" ? "Mevcut Şifre" : "Current Password"}</label>
                                                        <input className="form-control" type="password"
                                                            onChange={(e) => { setCurrent(sha256(e.target.value)) }}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="col-form-label">{lang === "tr" ? "Yeni Şifre" : "New Password"}</label>
                                                        <div className="input-group">
                                                            <Input onFocus={(e) => {
                                                                if (document.getElementById('password-rule-tooltip')) {
                                                                    document.getElementById('password-rule-tooltip').style.visibility = "visible"
                                                                }
                                                            }}
                                                                onBlur={(e) => {
                                                                    if (document.getElementById('password-rule-tooltip')) {
                                                                        document.getElementById('password-rule-tooltip').style.visibility = "hidden"
                                                                    }
                                                                }}
                                                                id='password' invalid={(passwordRules === null || passwordRules === "") ? false : passwordRulesValidate === false ? true : false} onChange={(e) => { setPass(sha256(e.target.value)); setPasswordRules(e.target.value) }} className="form-control" type={passwordInputType} />
                                                            <FormFeedback tooltip style={{ background: "#ffd4dc", width: "100%" }} id='password-rule-tooltip'>
                                                                <PasswordCheck password={passwordRules} passwordCheck={passwordCheck} id='password-rule-tooltip' />
                                                            </FormFeedback>
                                                            <div className="input-group-append">
                                                                <span className="input-group-text" style={{ cursor: 'pointer' }} onClick={togglePasswordVisibility}>
                                                                    <FontAwesomeIcon icon={isPasswordVisible ? faEyeSlash : faEye} />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label">{lang === "tr" ? "Yeni Şifrenizi Tekrar Yazınız" : "Confirm New Password"}</label>
                                                        <div className="input-group">
                                                            <input onChange={(e) => { setNewPass(sha256(e.target.value)) }} className="form-control" type={passwordInputType} />
                                                            <div className="input-group-append" style={{ cursor: 'pointer' }} onClick={togglePasswordVisibility}>
                                                                <span className="input-group-text">
                                                                    <FontAwesomeIcon icon={isPasswordVisible ? faEyeSlash : faEye} />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group form-row mb-2">
                                                        <div className="col-md-3">
                                                            <button onClick={resetPassword} className="btn btn-primary" type="submit">{lang === "tr" ? "Şifremi Değiştir" : "Change My Password"}</button>
                                                        </div>
                                                    </div>
                                                </form> :
                                                <form>
                                                    <Alert className="mt-1 " variant="danger" >{lang === "tr" ? "Yönlendirme linki zaman aşımına uğramıştır" : "Session Timeout!"}</Alert>
                                                    <div className='d-flex justify-content-end mt-3' >
                                                        <a href='/login'> Giriş Sayfasına Yönlendir </a>
                                                    </div>
                                                </form>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgetPwd;